import React from 'react';
import { Navbar, Nav, NavItem } from 'reactstrap';

const Footer = () => {
  return (
    <Navbar>
      <Nav navbar>
        <NavItem>
          ADIPSIK &#174; Asesmen Diagnostik Psikotes Komprehensif
        </NavItem>
      </Nav>
    </Navbar>
  );
};

export default Footer;
